<template>
    <v-container fluid>
        <page-header title="Referees" icon="mdi-whistle-outline">
            <template v-slot:actions>
                <v-btn class="white--text" depressed small color="black" @click="createReferee">
                    <v-icon left small>mdi-plus</v-icon>Create
                </v-btn>
            </template>
            <table-filters :fields="filterFields" :value="filterValues" @apply="applyFilters" />
        </page-header>
        <array-view
            :items="referees"
            :headers="displayInfo"
            :total-pages="totalPages"
            :page="page"
            :size="size"
            :sort-by="sort.sortBy"
            :sort-desc="sort.sortDesc"
            @handleClick="handleClick"
            @paginationChange="paginationChange"
            @sortChange="changeSort"
            @onDelete="onDelete"
        />
        <alert :show-alert="showAlert" :message="message" type="error" />
    </v-container>
</template>

<script>
    import refereeService from '@/services/referee'
    import ArrayView from '@/components/ArrayView'
    import TableFilters from '@/components/TableFilters'
    import PageHeader from '@/components/PageHeader'
    import Alert from '@/components/Alert'
    import listTable from '@/mixins/listTable'

    export default {
        name: 'Referee',
        components: { ArrayView, TableFilters, PageHeader, Alert },
        mixins: [listTable],
        data: () => {
            return {
                referees: [],
                displayInfo: [
                    {
                        text: 'Id',
                        value: 'id'
                    },
                    {
                        text: 'Name',
                        value: 'name'
                    }
                ],
                tableKey: 'referees',
                filterFields: [
                    { key: 'name', label: 'Name', type: 'text' }
                ],
                size: 10,
                totalPages: 0,
                page: 1,
                showAlert: false,
                message: null
            }
        },
        created() {
            this.fetchItems()
        },
        methods: {
            handleClick(action, item) {
                this.$router.push(`/referees/${item.id}/${action}`)
            },
            createReferee() {
                this.$router.push(`/referees/create`)
            },
            fetchItems() {
                refereeService.getFilteredReferees(this.filterQuery, this.page, this.size, this.sort).then(resp => {
                    this.referees = resp.data.content
                    this.totalPages = resp.data.totalPages
                })
            },
            onDelete(item, page) {
                refereeService.deleteReferee(item.id).then(() => {
                    this.page = page
                    this.fetchItems()
                }).catch(error => {
                    // e.g. the referee is already on matches
                    this.message = (error.response && error.response.data && error.response.data.message) || 'Referee cannot be deleted'
                    this.showAlert = true
                    setTimeout(() => { this.showAlert = false }, 7000)
                })
            }
        }
    }
</script>
